import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/pay/payQrCode/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/pay/payQrCode/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/pay/payQrCode/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/pay/payQrCode/submit', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/pay/payQrCode/update', params,options)

export const getUserDept = (params, options) =>
  request.get('/api/v4ward/pay/payQrCode/getUserDept', Object.assign({}, options, { params }));

export const getPage = (params, options) =>
  request.get('/api/v4ward/pay/payQrCode/page', Object.assign({}, options, { params }));

//关联销售方信息
export const linkSeller = (params, options) =>
  request.post('/api/v4ward/pay/payQrCode/link-seller', params,options)
